import { Cell } from 'components/Datatable';

import sliceDate from 'utils/helper';

const requestLogsColumns = [
  {
    minWidth: 120,
    Header: 'Type',
    accessor: 'type',
    Cell: ({ row }) => {
      const { type } = row.original;

      return <Cell content={type} />;
    },
  },
  {
    minWidth: 600,
    Header: 'Request',
    accessor: 'request',
    Cell: ({ row }) => {
      const { request } = row.original;

      return <Cell content={request} />;
    },
  },
  {
    minWidth: 350,
    Header: 'Error',
    accessor: 'error',
    Cell: ({ row }) => {
      const { error } = row.original;

      return <Cell content={error} />;
    },
  },
  {
    minWidth: 40,
    Header: 'Cost',
    accessor: 'cost',
    Cell: ({ row }) => {
      const { cost } = row.original;

      return <Cell content={cost} />;
    },
  },
  {
    minWidth: 30,
    Header: 'Time',
    accessor: 'time',
    Cell: ({ row }) => {
      const { time } = row.original;

      return <Cell content={time} />;
    },
  },
  {
    minWidth: 140,
    Header: 'Created At',
    accessor: 'createdAt',
    Cell: ({ row }) => {
      const { createdAt } = row.original;

      return <Cell content={sliceDate(createdAt)} />;
    },
  },
  {
    minWidth: 160,
    Header: 'Response Send At',
    accessor: 'responseSendAt',
    Cell: ({ row }) => {
      const { responseSendAt } = row.original;

      return <Cell content={sliceDate(responseSendAt)} />;
    },
  },
  {
    minWidth: 180,
    Header: 'Start Request',
    accessor: 'startShowapiRequest',
    Cell: ({ row }) => {
      const { startShowapiRequest } = row.original;

      return <Cell content={sliceDate(startShowapiRequest)} />;
    },
  },
  {
    minWidth: 180,
    Header: 'End Request',
    accessor: 'endShowapiRequest',
    Cell: ({ row }) => {
      const { endShowapiRequest } = row.original;

      return <Cell content={sliceDate(endShowapiRequest)} />;
    },
  },
  {
    minWidth: 140,
    Header: 'Res Id',
    accessor: 'showapiResId',
    Cell: ({ row }) => {
      const { showapiResId } = row.original;

      return <Cell content={showapiResId} />;
    },
  },
];

export default requestLogsColumns;
